<template lang="pug">
  .page-skeleton-container
    .page-skeleton-name page-skeleton
    .page-skeleton-header
      ExchangeGoodsSkeleton
    .page-skeleton-content
      .page-skeleton-content-header
      .page-skeleton-content-main
        RakeBackSkeleton(class='page-skeleton-content-main-item')
        VideoRedPacketSkeleton(class='page-skeleton-content-main-item')
        TaskSkeleton(class='page-skeleton-content-main-item')
</template>

<script>
import SkeletonItem from '@/components/skeleton-item';
import ExchangeGoodsSkeleton from './exchange-goods-skeleton';
import RakeBackSkeleton from './rake-back-skeleton';
import TaskSkeleton from './task-skeleton';
import VideoRedPacketSkeleton from './video-red-packet-skeleton';

export default {
  name: 'PageSkeleton',
  components: {
    SkeletonItem,
    ExchangeGoodsSkeleton,
    RakeBackSkeleton,
    TaskSkeleton,
    VideoRedPacketSkeleton,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.page-skeleton-container {
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-color: #eff3f5;

  .page-skeleton-name {
    display: none;
    background-color: transparent;
  }

  .page-skeleton-header {
    display: flex;
    align-items: flex-end;
    margin-bottom: -0.31rem;
    padding: 0 0.08rem 0.4rem;
    height: 3.61rem;
    background-image: linear-gradient(90deg, #275edd 0%, #4297e5 100%);
    box-sizing: border-box;
  }

  .page-skeleton-content-header {
    margin-bottom: -0.425rem;
    height: 0.5rem;
    background-image: linear-gradient(180deg, #d0e3ff 0%, #f0f3f5 39.02%);
    border-top: 0.01rem solid #fff;
    border-radius: 0.16rem 0.16rem 0 0;
  }

  .page-skeleton-content-main {
    padding: 0 0.12rem;
  }

  .page-skeleton-content-main-item {
    margin-bottom: 0.08rem;
  }
}
</style>
